import { Chip, Sheet, Table } from "@mui/joy";
import { SDelete, SEdit } from "../../../../styles/StyledMUI";
import { hrAccentColor, hrSheetSx, hrTableSx, textTokens } from "../../../../styles/globalStyles";
import DarkCard from "../../../common/DarkCard";
import DarkTypography from "../../../common/DarkTypography";
import IconButtonCTA from "../../../common/IconButtonCTA";
import type { RentalProduct } from "../../../../api/rental/Rental.typed";
import { formatPrice, htToTtc } from "../../shared/billingUtils";

type Props = {
  items: RentalProduct[];
  modelLabelById: Map<number, string>;
  canEdit: boolean;
  onEdit: (p: RentalProduct) => void;
  onDelete: (p: RentalProduct) => void;
};

export default function RentalProductCard({
  items,
  modelLabelById,
  canEdit,
  onEdit,
  onDelete,
}: Props) {
  return (
    <DarkCard dense>
      <DarkTypography level="title-md" sx={{ mb: 0.5, color: hrAccentColor }}>
        Kits de location
        <DarkTypography
          component="span"
          level="body-sm"
          sx={{ color: textTokens.color.faint, ml: 1 }}
        >
          ({items.length} kit{items.length > 1 ? "s" : ""})
        </DarkTypography>
      </DarkTypography>
      <Sheet sx={hrSheetSx}>
        <Table hoverRow sx={hrTableSx}>
          <thead>
            <tr>
              <th>Nom</th>
              <th>Composition</th>
              <th>Tarif jour HT</th>
              <th>TVA</th>
              <th>Tarif jour TTC</th>
              <th>Statut</th>
              {canEdit && <th style={{ width: 100 }}>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id}>
                <td>{p.name}</td>
                <td>
                  {(p.lines ?? []).length === 0
                    ? "—"
                    : (p.lines ?? []).map((l) => (
                        <Chip key={l.id} size="sm" variant="soft" sx={{ mr: 0.5, mb: 0.25 }}>
                          {modelLabelById.get(l.equipment_model_id) ??
                            l.equipment_model?.Name ??
                            `#${l.equipment_model_id}`}{" "}
                          ×{l.quantity}
                        </Chip>
                      ))}
                </td>
                <td>{formatPrice(p.price_ht, p.currency)}</td>
                <td>{p.tax_rate} %</td>
                <td>{formatPrice(htToTtc(p.price_ht, p.tax_rate), p.currency)}</td>
                <td>
                  <Chip size="sm" color={p.is_active ? "success" : "neutral"} variant="soft">
                    {p.is_active ? "Actif" : "Inactif"}
                  </Chip>
                </td>
                {canEdit && (
                  <td>
                    <IconButtonCTA aria-label="Modifier" size="sm" onClick={() => onEdit(p)}>
                      <SEdit />
                    </IconButtonCTA>
                    <IconButtonCTA
                      aria-label="Supprimer"
                      size="sm"
                      ctaVariant="danger"
                      onClick={() => onDelete(p)}
                    >
                      <SDelete />
                    </IconButtonCTA>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </Sheet>
    </DarkCard>
  );
}
